module.exports = __webpack_public_path__ + "img/ics_o_filter.99e57a25.svg";